import { ReactNode } from 'react'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

import { SearchButton } from '../../search-button'
import StarRating from '../../star-rating/star-rating'

import styles from './verdict.module.css'
import sharedStyles from '../../../car-reviews-v2.module.css'
import { StoryBlokCarReviewSection } from '../../../types/car-review-page'

export interface VerdictProps {
  title: string
  body: ReactNode
  starRating: number
  make: string
  model: string
  reviewSections: StoryBlokCarReviewSection[]
  areVehiclesInStock?: boolean
}

export const Verdict: React.FC<VerdictProps> = ({
  title,
  body,
  starRating,
  make,
  model,
  reviewSections,
  areVehiclesInStock,
}) => {
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      eventName: `Car Review - Search for a ${make} ${model}`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'verdict',
          label: 'search for a vehicle',
          action: make,
          value: model,
        },
      },
    })
  }

  return (
    <section className={sharedStyles.inner} id="verdict">
      <div className={styles.verdictInner}>
        <div className={styles.heading}>
          <h2 className={styles.title}>{title || 'The verdict'}</h2>
          <StarRating starRating={starRating} />
        </div>
        <div className={styles.sectionVerdictWrapper}>
          {reviewSections.map((section, index) => (
            <div className={styles.sectionVerdict} key={section.title}>
              <h3 className={styles.verdictSectionsTitle}>{section.title}</h3>
              <p className={styles.verdictSectionsRating}>
                {section.rating}/10
              </p>
            </div>
          ))}
        </div>
        <div className={styles.content}>{body} </div>
      </div>
      {areVehiclesInStock && (
        <SearchButton
          make={make}
          model={model}
          className={styles.verdictSearchButton}
          onClick={() => handleClick()}
        />
      )}
    </section>
  )
}
